import Header from "./components/Header";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import NewsFeed from "./components/NewsFeed";
import Columns from "./components/Columns";
import Stars from "./components/Stars";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

const siteSchema = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "明星爆料",
    url: "https://readdy.ai/",
    description: "聚合公开娱乐报道，按剧集、音乐、红毯与行业话题分类，一次看全明星热点事件脉络。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: { "@type": "EntryPoint", urlTemplate: "https://readdy.ai/?q={search_term_string}" },
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "明星爆料",
    url: "https://readdy.ai/",
    logo: "https://readdy.ai/vite.svg",
    sameAs: [],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "本站更新的明星资讯都来自哪里？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "本站内容均整理自公开渠道的新闻报道、官方发布与已公开的采访素材，对时效性强、来源多元的话题我们会标注事件进展，不收录任何未经证实的私人录音或聊天记录类材料。",
        },
      },
      {
        "@type": "Question",
        name: "「一次看全事件脉络」具体是什么意思？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "我们会对同一热点事件下的剧集动态、红毯造型、音乐现场、行业访谈等不同形式的公开内容做汇总串联，按时间顺序整理进展，让你不用在各个平台来回切换就能看清来龙去脉。",
        },
      },
      {
        "@type": "Question",
        name: "为什么分为视频、图文、长文等不同栏目？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "不同形式的内容阅读场景不同：短视频适合快速了解现场，图文长文适合深度理解背景。按形式分类能让内容浏览更高效，也方便你按喜好选择。",
        },
      },
      {
        "@type": "Question",
        name: "内容里的「热榜趋势」多久更新一次？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "热榜基于公开讨论热度滚动更新，我们会在站内标注排行变化与上升趋势，帮助判断哪些话题正处于讨论高点。",
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Trending />
        <NewsFeed />
        <Columns />
        <Stars />
        <Faq />
        <About />
      </main>
      <Footer />
      {siteSchema.map((s, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(s) }} />
      ))}
    </>
  );
}